import * as React from 'react';
import { Waypoint } from 'react-waypoint';
import { ElementLoader } from 'ui';
import { ids } from 'app/area/administration/constants';
import { SearchTileProps } from './types';
import { SearchResults } from '../types-store';

import styles from './search-result.scss';
import { DefaultRole } from 'app/area/administration/shared/types';
import { SearchTranslation } from 'app/area/administration/list/constants';
import { MergeUserState } from 'app/area/administration/shared/merge-user/types-store';

interface SearchResultProps {
  results: SearchResults;
  noHitLabel: string;
  canDuplicate: boolean;
  translation: SearchTranslation;

  resultTile: React.FC<SearchTileProps>;

  onFetchMore: () => void;
  onDelete: (id: number) => void;
  onLoadPersonAccess: (id: number) => void;
  onClearPersonAccess: () => void;
  setDefaultRole?: (defaultRole: DefaultRole) => void;
  settingDefaultRoleId?: number;

  showMeatball: boolean;
  defaultRole?: DefaultRole;

  mergeUser?: MergeUserState;
  updateMergeUser?: (mergeUser: MergeUserState) => void;
}

export const SearchResult: React.FC<SearchResultProps> = (props) => {

  const { noHitLabel, canDuplicate, translation, resultTile: Tile, onFetchMore, onDelete, onLoadPersonAccess, onClearPersonAccess,
    setDefaultRole, settingDefaultRoleId, showMeatball, defaultRole, mergeUser,  updateMergeUser } = props;
  const { fetching = false, total, list = [], itemPersonAccess } = props.results;

  if (total === 0 && !fetching) {
    return <p id={ids.no_hits} className={styles.searchHits}>
      {noHitLabel}
    </p>;
  }

  return <>
    {!!total && <div id={ids.number_of_hits} className={styles.searchHits}>
      {total} {translation.search_hits}
    </div>}
    {!!list && list
      .map(item =>
        <Tile
          key={item.id}
          data={item}
          itemPersonAccess={itemPersonAccess}
          translation={translation}
          canDuplicate={canDuplicate}
          onDelete={!item.deleted && onDelete}
          onLoadPersonAccess={onLoadPersonAccess}
          onClearPersonAccess={onClearPersonAccess}
          setDefaultRole={setDefaultRole}
          settingDefaultRoleId={settingDefaultRoleId}
          showMeatball={showMeatball}
          defaultRole={defaultRole}
          mergeUser={mergeUser}
          updateMergeUser={updateMergeUser} />
      )}
    <Waypoint key="wpRole" onEnter={onFetchMore} scrollableAncestor={window} bottomOffset="-10%" />
    {fetching ? <ElementLoader /> : null}
  </>;
};
